import { curry, isEmpty } from 'lodash/fp';
import { isEmail, isLength } from 'validator';

export const makeRequired = message => val => (!isEmpty(val) ? undefined : message);

export const required = makeRequired('Required');

export const emptyOrEmail = val => (isEmpty(val) || isEmail(`${val}`) ? undefined : 'Must be a valid email');

const emptyOrMaxLength = curry((max, val) => (
  isLength(`${val}`, { max }) ? undefined : `Must be less than ${max} characters`
));

export const emptyOrMaxLength100 = emptyOrMaxLength(100);

const emptyOrMinLength = curry((min, val) => (
  isLength(`${val}`, { min }) ? undefined : `Must be at least ${min} characters`
));

export const emptyOrMinLength8 = emptyOrMinLength(8);

const specialCharacterRegex = /[=+-^$*[\]{}()?!@#&%|_~]/;

export const hasSpecialCharacters = value => (
  (value === undefined || specialCharacterRegex.test(value))
    ? undefined
    : 'Must include at least one of these special characters: = + - ^ $ * [ ] { } ( ) ? ! @ # & % | _ ~'
);

const lowerCaseRegex = /[a-z]/;

export const hasLowerCaseLetters = value => (lowerCaseRegex.test(value) ? undefined : 'Must include a lower case letter');

export const sameAsNewPassword = (value, allValues) => {
  const { newPassword } = allValues;
  if ([newPassword, value].includes(undefined)) {
    return undefined;
  }
  return value === newPassword ? undefined : 'Must be the same as new password';
};



// WEBPACK FOOTER //
// ./js/support/validators/general/index.jsx